import { Radio as MuiRadio, RadioProps as MuiRadioProps, styled } from "@mui/material";

const StyledRadio = styled(MuiRadio)(({ theme }) => {
  return {
    color: theme.palette.toggleButton.background,
    "&.Mui-checked": {
      color: theme.palette.toggleButton.background,
    },
  };
});

interface RadioProps extends MuiRadioProps {}

export const Radio: React.FC<RadioProps> = ({ ...props }) => {
  return <StyledRadio {...props} />;
};

export default Radio;
